import { put, call } from 'redux-saga/effects';
import readJsonDataService from '../../services/readJsonData.services';
import { constants } from '../../constants';
import { decompress } from 'compress-json';

import { 
  getExamCentersSuccess,
  getExamCentersError,
  toggleAlertShowStatus} from '../actions';


export default function * getExamCentreList () {
  try {
    const res = yield call([readJsonDataService, 'getExamCentreList'])

    //making sure redux store will update if api save is successful
    const decompedJson = decompress(res.body);
    yield put(getExamCentersSuccess(decompedJson.Centres));
  } catch (error) {
    yield put(toggleAlertShowStatus({
      showAlert: true,
      alertVarient:'danger',
      alertMessage: constants.APP_MESSAGE.API_RETRIVE_ERROR
    }));

    yield put(getExamCentersError()) 
  }
}
